import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class AssessmentService {

  constructor(public http: HttpClient) {
  }

  all(): Observable<any> {
    const url = environment.baseUrl + '/api/v2/client/meu-desempenho';
    return this.http.get(url, {headers: this.getHeader()});
  }

  fetch(id: number): Observable<any> {
    const url = environment.baseUrl + '/api/v2/client/meu-desempenho/' + id;
    return this.http.get(url, {headers: this.getHeader()});
  }

  find(id: number): Observable<any> {
    const url = environment.baseUrl + '/api/v2/client/pasta-assessment/' + id;
    return this.http.get(url, {headers: this.getHeader()});
  }

  getScore(data: any) {
    const url = environment.baseUrl + '/api/v2/client/pasta-assessment/pergunta/post';
    return this.http.post(url, data, {headers: this.getHeader()});
  }

  getReportIndicador(): Observable<any> {
    const url = environment.baseUrl + '/api/v2/report/indicador';
    return this.http.get(url, {headers: this.getHeader()});
  }

  getReportTema(): Observable<any> {
    const url = environment.baseUrl + '/api/v2/report/tema';
    return this.http.get(url, {headers: this.getHeader()});
  }

  getReportEixo(): Observable<any> {
    const url = environment.baseUrl + '/api/v2/report/eixo';
    return this.http.get(url, {headers: this.getHeader()});
  }

  postConfirmAssessment(banner_id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/api/v2/client/banner/view/post',
      {banner_id: banner_id},
      {headers: this.getHeader()});
  }

  assessmentBannerViewed(assessment_id: number): Observable<any> {
    return this.http.post(
      environment.baseUrl + '/api/v2/client/meu-desempenho/view',
      {assessment_id: assessment_id},
      {headers: this.getHeader()}
    );
  }

  getHeader(): HttpHeaders {
    const token = sessionStorage.getItem('token');
    const headerOptions = {
      'Authorization': token,
      'Accept': 'application/json'
    };
    return new HttpHeaders(headerOptions);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/assessment.service.ts